import React from 'react';
import DefaultAppHeader from './DefaultAppHeader.js';
import PublicReportsAppHeader from './PublicReportsAppHeader.js';
import { withRouter } from 'react-router';

const AppHeader = (props) => {
  const { pathname } = props.location;
  if ((pathname || '').includes('report') && !(pathname || '').includes('reports')) {
    return <PublicReportsAppHeader />;
  }
  return <DefaultAppHeader />;
};

export default withRouter(AppHeader);
